import { render, staticRenderFns } from "./RoleAssignModal.vue?vue&type=template&id=f34a19c0&scoped=true"
import script from "./RoleAssignModal.vue?vue&type=script&lang=js"
export * from "./RoleAssignModal.vue?vue&type=script&lang=js"
import style0 from "./RoleAssignModal.vue?vue&type=style&index=0&id=f34a19c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34a19c0",
  null
  
)

export default component.exports